import { PurposeEnum, StatusEnum } from "../enums";

export class MaterialRequestModel {
  date: Date;
  module: string;
  shiftId: number;
  machineTypeId: number;
  needleModelId: number;
  needleSizeId: number;
  needleQuantity: string;
  purpose: PurposeEnum;
  status: StatusEnum;
  isActive: boolean;
  createdAt: Date;
  createdUser: string;
  updatedAt: Date;
  updatedUser: string;
  versionFlag: number;
  stockInId:number;
  needlePointId:number;
  mechanicName:string;

  constructor(
    date: Date,
    module: string,
    shiftId: number,
    machineTypeId: number,
    needleModelId: number,
    needleSizeId: number,
    needleQuantity: string,
    purpose: PurposeEnum,
    status: StatusEnum,
    isActive: boolean,
    createdAt: Date,
    createdUser: string,
    updatedAt: Date,
    updatedUser: string,
    versionFlag: number,
    stockInId:number,
    needlePointId:number,
    mechanicName:string,
    
  ) 
  {
    this.date = date;
    this.module = module;
    this.shiftId = shiftId;
    this.machineTypeId = machineTypeId;
    this.needleModelId = needleModelId;
    this.needleSizeId = needleSizeId;
    this.needleQuantity = needleQuantity;
    this.purpose = purpose;
    this.status = status;
    this.isActive = isActive;
    this.createdAt = createdAt;
    this.createdUser = createdUser;
    this.updatedAt = updatedAt;
    this.updatedUser = updatedUser;
    this.versionFlag = versionFlag;
    this.stockInId=stockInId;
    this.needlePointId=needlePointId
    this.mechanicName=mechanicName;
  }
}
